'use es6';

import keyMirror from 'react-utils/keyMirror';
export const BLOCK_TYPE = 'atomic';
export const ATOMIC_TYPE = 'unsubscribe';
export const DATA_ATTRIBUTE = 'data-hs-unsubscribe';
export const LOCALE_DATA_ATTRIBUTE = 'data-hs-unsubscribe-locale';
export const LINK_TYPE_ATTRIBUTE = 'data-hs-linktype';
export const LINK_TOKEN = '{{ unsubscribe_link }}';
export const LINK_TYPES = keyMirror({
  RELEVANT: null,
  STOP_GETTING_MESSAGES: null,
  PREFER_LESS: null
});
export const NO_UNSUBSCRIBE_LINK = 'NO_UNSUBSCRIBE_LINK';